import { render } from "./FAQManagementIcon.vue?vue&type=template&id=042f3b12"
import script from "./FAQManagementIcon.vue?vue&type=script&lang=js"
export * from "./FAQManagementIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FAQManagementIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "042f3b12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('042f3b12', __exports__)) {
    api.reload('042f3b12', __exports__)
  }
  
  module.hot.accept("./FAQManagementIcon.vue?vue&type=template&id=042f3b12", () => {
    api.rerender('042f3b12', render)
  })

}


export default __exports__